<template>
  <div class="tab-card-container">
    <div class="tab-list">
      <div
        v-for="(tab, index) in tabList"
        class="tab-item"
        :key="index"
        :class="activeTab.pageType === tab.pageType && 'is-active'"
        @click="onTabClick(tab)"
      >
        <div class="tab-name-wrapper">
          <span class="tab-name">{{ tab.label || $t(tab.labelI18nKey) }}</span>
          <div class="name-line"></div>
        </div>
        <slot :name="tab.suffix"></slot>
      </div>
    </div>
    <div class="tab-content-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    activeTab: {
      type: Object,
      required: true
    },
    tabList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    onTabClick (tab) {
      this.$emit('change', tab)
    }
  }
}
</script>

<style lang="scss" scoped>
$border-color: #aaa;

.tab-card-container {
  display: flex;
  flex-direction: column;

  .tab-list {
    display: flex;
    border-bottom: 1px solid #dcdfe6;

    .tab-item {
      flex: 1;
      margin-bottom: -1px;
      border: 1px solid #dcdfe6;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      background: #dcdcdd;
      text-align: center;
      cursor: pointer;
      position: relative;

      &.is-active {
        border-bottom: 0;
        background: #fff;
        color: #0096cc;

        .tab-name-wrapper {
          .name-line {
            visibility: visible;
          }
        }
      }

      &:not(.is-active):hover {
        border-bottom: 0;
        background: #fff;

        .tab-name-wrapper {
          .name-line {
            border-color: $border-color;
            visibility: visible;
          }
        }
      }

      & + .tab-item {
        margin-left: 12px;
      }

      .tab-name-wrapper {
        display: inline-block;

        .tab-name {
          display: inline-block;
          padding: 2px 4px;
          line-height: 26px;
          font-size: 18px;
          white-space: nowrap;
          word-break: keep-all;
          color: #606266
        }

        .name-line {
          margin: 0 auto;
          width: 96px;
          border: 1px solid #0096cc;
          border-radius: 10px;
          visibility: hidden;
        }
      }
    }
  }

  .tab-content-container {
    flex: 1;
    border: 1px solid #dcdfe6;
    border-top: 0;
    position: relative;
  }
}
</style>
